<template>
  <b-row class="m-0 bg-light">
    <b-col cols="7" class="p-0">
      <span class="font-weight-bold text-main2">
        {{ titleByTimeDateId(timeDayId) }}
      </span>
    </b-col>
    <b-col cols="2" class="p-0 text-center">
      <small class="text-muted"> Yes </small>
    </b-col>
    <b-col cols="2" class="p-0 text-center">
      <small class="text-muted"> No </small>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    timeDayId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      dayTimes: {
        '1': {
          title: 'Morning',
        },
        '2': {
          title: 'Afternoon',
        },
        '3': {
          title: 'Evening',
        },
        '4': {
          title: 'Anytime',
        },
      },
    };
  },
  methods: {
    titleByTimeDateId(timeDayId) {
      return this.dayTimes[timeDayId].title;
    },
  },
};
</script>
